export const get7DayBtcClosingPrices = async (vsCurrency = "cad") => {
  const url = `https://api.coingecko.com/api/v3/coins/bitcoin/market_chart?vs_currency=${vsCurrency}&days=7`;
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`CoinGecko API error: ${res.status} ${res.statusText}`);
  }
  const { prices } = await res.json();

  const dailyClose = new Map();
  prices.forEach(([timestampMs, price]: any) => {
    const day = new Date(timestampMs).toISOString().slice(0, 10);
    dailyClose.set(day, Math.round(price));
  });

  const last7 = Array.from(dailyClose.keys()).sort().slice(-7);

  return last7.map((day) => dailyClose.get(day));
};
